import { render, staticRenderFns } from "./OrganizationStory.vue?vue&type=template&id=9cf1a40c&scoped=true&"
import script from "./OrganizationStory.vue?vue&type=script&lang=js&"
export * from "./OrganizationStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf1a40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cf1a40c')) {
      api.createRecord('9cf1a40c', component.options)
    } else {
      api.reload('9cf1a40c', component.options)
    }
    module.hot.accept("./OrganizationStory.vue?vue&type=template&id=9cf1a40c&scoped=true&", function () {
      api.rerender('9cf1a40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/organization/OrganizationStory.vue"
export default component.exports